import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type FeedbacksSystemSettings as SchemaFeedbacksSystemSettings } from '../schemas/FeedbacksSystemSettings';
import { type IntegrationProblemType as SchemaIntegrationProblemType } from '../schemas/IntegrationProblemType';
import { type IntegrationType as SchemaIntegrationType } from '../schemas/IntegrationType';
import { type Problem as SchemaProblem } from '../schemas/Problem';
import { type UpdateFeedbacksSettingsRequest as SchemaUpdateFeedbacksSettingsRequest } from '../schemas/UpdateFeedbacksSettingsRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Integrations
 */
export const UpdateIntegrationFeedbacksSettingsContentType = 'application/json' as const;
export type UpdateIntegrationFeedbacksSettingsRequest = SchemaUpdateFeedbacksSettingsRequest;
export type UpdateIntegrationFeedbacksSettingsResponses = LinkCommonErrorResponses & {
    /**
     * @description Feedbacks settings updated successfully
     */
    '200': {
        'application/json': SchemaFeedbacksSystemSettings;
    };
    /**
     * @description Invalid input or feedbacks access is not granted
     */
    '400': {
        'application/json': SchemaProblem & {
            type: SchemaIntegrationProblemType;
        };
    };
};
export type UpdateIntegrationFeedbacksSettingsResponseSuccess =
    UpdateIntegrationFeedbacksSettingsResponses['200']['application/json'];
export type UpdateIntegrationFeedbacksSettingsSearchParams = undefined;
export type UpdateIntegrationFeedbacksSettingsPathParameters = {
    integration_type: SchemaIntegrationType;
};
export const UpdateIntegrationFeedbacksSettingsUrl = '/integrations/settings/feedbacks/{integration_type}' as const;
export const UpdateIntegrationFeedbacksSettingsMethod = 'PATCH' as const;
export const getUpdateIntegrationFeedbacksSettingsUrl = (params: UpdateIntegrationFeedbacksSettingsPathParameters) =>
    UpdateIntegrationFeedbacksSettingsUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof UpdateIntegrationFeedbacksSettingsPathParameters) => String(params[param])
    );
